import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../core/services/session.service';
import { UtilityService } from '../../core/services/utility.service';
import { QuestionAnswerService } from '../../core/services/question-answer.service';
import { Session } from '../../core/models/session';
import { Questions } from '../../core/models/question-answer';

@Component({
  selector: 'app-question-and-answer',
  templateUrl: './question-and-answer.component.html',
  styleUrls: ['./question-and-answer.component.css'],
  providers: [QuestionAnswerService]
})
export class QuestionAndAnswerComponent implements OnInit {
  eventId: string = '';
  sessionId: string = '';
  questions = new Questions();
  questionAllList: Array<any> = new Array();
  questionEventList: Array<any> = new Array();
  questionSessionList: Array<any> = new Array();
  prop: string = 'all';

  constructor(private questionAnswerService: QuestionAnswerService, private extraService: ExtraService, private route: ActivatedRoute, private router: Router,
    private sessionService: SessionService, private utilityService: UtilityService) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      this.eventId = id;
      this.extraService.setCurrentEventId(id);
      this.setAllQuestionAnswer(id);
    });
  }

  receiveSession($event) {

    this.questionAllList = new Array();
    this.questionEventList = new Array();
    this.questionSessionList = new Array();

    if ($event.prop == 'all' && !$event.sessionId) {
      this.prop = $event.prop;
      this.setAllQuestionAnswer(this.eventId);
    } else if ($event.prop == 'event' && !$event.sessionId) {
      this.prop = $event.prop;
      this.setEventQuestionAnswer(this.eventId);
    } else if ($event.prop == 'session') {
      this.prop = $event.prop;
      if ($event.sessionId) {
        this.setSessionQuestionAnswer(this.eventId, $event.sessionId);
      }

    }
  }

  setAllQuestionAnswer(eventId) {
    this.questionAnswerService.getAllQuestionAnswer(eventId).subscribe(event => {
      if (event) {
        console.log(event)
        //this.prop = null;
        this.questions = event;
        for (let key in event) {
          let question = event[key].question;
          let answer = event[key].answer;
          this.questionAllList.push({ question: question, answer: answer });
        }
        console.log(this.questionAllList, this.prop)
      } else {
        this.prop = 'noData';
      }
    });
  }

  setEventQuestionAnswer(eventId) {

    this.questionAnswerService.getEvenQuestionAnswer(eventId).subscribe(event => {
      if (event) {
        // this.prop = null;
        this.questions = event;
        for (let key in event) {
          if (event[key].eventId != null && event[key].eventId == this.eventId && event[key].sessionId == null) {
            let question = event[key].question;
            let answer = event[key].answer;
            this.questionEventList.push({ question: question, answer: answer });
          }
        }
        console.log(this.questionAllList, this.prop)
      } else {

        this.prop = 'noData';
        console.log(this.questionAllList, this.prop)
      }
    });
  }

  setSessionQuestionAnswer(eventId, sessionId) {
    if (sessionId) {
      console.log(this.questionAllList, sessionId);
      this.questionAnswerService.getSessionQuestionAnswer(eventId).subscribe(event => {
        if (event) {
          console.log(this.questionAllList, sessionId);
          // this.prop = null;
          this.questions = event;
          for (let key in event) {

            if (event[key].sessionId != null && event[key].eventId == this.eventId && event[key].sessionId == sessionId) {

              let question = event[key].question;
              let answer = event[key].answer;
              this.questionSessionList.push({ question: question, answer: answer });

            } else {
              this.prop = 'noData';
              console.log(this.questionAllList, this.prop);
            }

          }
        } else {
          this.prop = 'noData';
          console.log(this.questionAllList, this.prop);
        }

      });

    }

  }

}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/question-and-answer/question-and-answer.component.ts